import { createFileRoute } from '@tanstack/react-router';
import { useAuth } from '@/hooks/use-auth';
import { ROLES } from '@/constants/roles.constants';
import { BaseLayout } from '@/components/utility/base-layout/base-layout';

import {
  AdminDashboard,
  ExecutiveDashboard,
  ManagerDashboard,
  DriverDashboard,
  StaffDashboard,
} from '@/components';

export const Route = createFileRoute('/dashboard/')({
  component: Dashboard,
});

function Dashboard() {
  const { user } = useAuth();

  const renderDashboard = () => {
    switch (user?.role) {
      case ROLES.DRIVER:
        return <DriverDashboard />;

      case ROLES.ADMINISTRATOR:
        return <AdminDashboard />;

      case ROLES.STAFF:
        return (
          <BaseLayout
            header={{
              headerText: user?.name || 'Staff',
              subHeaderText: user?.hierarchyLevel?.name
                ? `${user?.account} | ${user?.hierarchyLevel?.name}`
                : user?.account || undefined,
            }}
            breadcrumbs={{
              showBreadcrumbs: false,
            }}
          >
            <StaffDashboard
              organizationLevelUuid={user?.hierarchyLevel?.uuid}
              userUuid={user?.uuid}
            />
          </BaseLayout>
        );
      case ROLES.EXECUTIVE:
        return (
          <BaseLayout
            header={{
              headerText: user?.name || 'Executive',
              subHeaderText: user?.hierarchyLevel?.name
                ? `${user?.account} | ${user?.hierarchyLevel?.name}`
                : user?.account || undefined,
            }}
            breadcrumbs={{
              showBreadcrumbs: false,
            }}
          >
            <ExecutiveDashboard
              organizationLevelUuid={user?.hierarchyLevel?.uuid}
              userUuid={user?.uuid}
              liveAlerts
            />
          </BaseLayout>
        );

      case ROLES.MANAGER:
        return (
          <BaseLayout
            header={{
              headerText: user?.name || 'Manager',
              subHeaderText: user?.hierarchyLevel?.name
                ? `${user?.account} | ${user?.hierarchyLevel?.name}`
                : user?.account || undefined,
            }}
            breadcrumbs={{
              showBreadcrumbs: false,
            }}
          >
            <ManagerDashboard
              organizationLevelUuid={user?.hierarchyLevel?.uuid}
              userUuid={user?.uuid}
              liveAlerts
            />
          </BaseLayout>
        );

      default:
        return null;
    }
  };

  return <div>{renderDashboard()}</div>;
}
